module.exports = __webpack_public_path__ + "img/projectmanager.67780a62.png";